export const SITE_URL = 'https://gatagam.in';
export const ADMIN_URL = 'https://admin.gatagam.in';